"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeUnwrappedDimensions = computeUnwrappedDimensions;
function computeUnwrappedDimensions(lines) {
    return lines.reduce((longestUnwrappedDimensions, line) => {
        if (!line.dimensions)
            return longestUnwrappedDimensions;
        const { lengthInMillimeters, widthInMillimeters, heightInMillimeters } = line.dimensions;
        const unwrappedDimensions = [lengthInMillimeters, widthInMillimeters, heightInMillimeters]
            .sort((a, b) => {
            return b - a;
        })
            .reduce((unwrappedDimensionsAcc, dimension, index) => {
            if (index === 0)
                return unwrappedDimensionsAcc + dimension;
            return unwrappedDimensionsAcc + dimension * 2;
        }, 0);
        return longestUnwrappedDimensions > unwrappedDimensions ? longestUnwrappedDimensions : unwrappedDimensions;
    }, 0);
}
